import { useLocation } from "@tanstack/react-router"


import { Navigator } from "@/routes/Navigator.ts"
import { useCurrentOrgId } from "@/routes/projects/projectHooks.ts"

import type { MatterLocation } from "@/context.ts"
import type { ProjectKey } from "@/lib/client/generated/TypeDefinitions.ts"

export function useOrgHomeLocation() {
  return Navigator.orgHome(useCurrentOrgId())
}

export function useProjectLocation(projectKey: ProjectKey): MatterLocation {
  const orgId = useCurrentOrgId()
  return Navigator.project(orgId, projectKey)
}

export function useNewProjectLocation(): MatterLocation {
  const orgId = useCurrentOrgId()
  const location = useLocation()

  return Navigator.newProject(orgId, {
    closeLocation: { href: location.href }
  })
}

export function useNewTaskLocation(projectKey: ProjectKey | undefined): MatterLocation {
  const orgId = useCurrentOrgId()
  const location = useLocation()

  if (!projectKey) return Navigator.orgHome(orgId)

  return Navigator.newTask(orgId, projectKey, {
    closeLocation: { href: location.href }
  })
}

export function useCloseLocation(defaultLocation: MatterLocation): MatterLocation {
  return useLocation().state?.closeLocation || defaultLocation
}